<!--
 * @LastEditTime: 2024-01-04 15:14:36
 * @Description: 今日统计组件
 * @FilePath: \sheyang\src\module\energyStorage\leftContent\toadyStat.vue
-->
<template>
  <div class="today-stat">
    <div style="width: 100%;">
      <pub-info-title :title="'今日统计'" />
    </div>
    <div class="content">
      <!-- :value="storedChargingAmountTotal" -->
      <div class="unit-content">
        <pub-info-list-unit-item
          :label="'充电量'"
          :value="storedChargingAmountTotal"
          :unit="'kWh'"
        />
      </div>

      <div class="charging-content">
        <div class="sys-content" v-for="(item, index) in today" :key="index">
          <div class="sys-bg" :style="{ backgroundImage: 'url(' + item.bg + ')' }">
            <div class="sys-fgc" :class="'fgc' + (index + 1)">
              <div class="sys-info">
                <span>充 </span>
                <p v-if="index === 0">{{ todayData.storedChargingAmountJ | toDecimal }}</p>
                <p v-if="index === 1">{{ todayData.storedChargingAmountF | toDecimal }}</p>
                <p v-if="index === 2">{{ todayData.storedChargingAmountP | toDecimal }}</p>
                <p v-if="index === 3">{{ todayData.storedChargingAmountG | toDecimal }}</p>
                <span>度</span>
              </div>
               <!-- <div class="sys-info">
                <span>放 </span>
                <p v-if="index === 0">{{ todayData.storedDisChargingAmountJ | toDecimal }}</p>
                <p v-if="index === 1">{{ todayData.storedDisChargingAmountF | toDecimal }}</p>
                <p v-if="index === 2">{{ todayData.storedDisChargingAmountP | toDecimal }}</p>
                <p v-if="index === 3">{{ todayData.storedDisChargingAmountG | toDecimal }}</p>
                <span>度</span>
              </div> -->
            </div>
          </div>
          <img :src="item.icon" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pubInfoTitle from '@/components/infoTitle/index.vue';
import pubInfoListUnitItem from '@/components/infoListUnitItem/index.vue';

export default {
  name: 'toady-stat',
  components: {
    pubInfoTitle,
    pubInfoListUnitItem,
  },
  props: {
    todayData: {
      type: Object,
      default: () => {},
    },
  },
  filters: {
    // 保留一位小数 String
    toDecimal(val) {
      return val ? val.toFixed(0) : '0';
    },
  },
  computed: {
    ...mapGetters('overView', ['pvStats']),
    // 充/放电量
    storedChargingAmountTotal() {
      const { storedChargingAmountTotal, storedDisChargingAmountTotal } = this.todayData;
      // return `${this.toDecimal(storedChargingAmountTotal)}/${this.toDecimal(storedDisChargingAmountTotal)}`;
      return `${this.toDecimal(storedChargingAmountTotal)}`;
    },
  },
  data() {
    return {
      today: [
        {
          title: '尖',
          icon: require('@/assets/images/chargingStatistics/jianIcon.png'),
          bg: require('@/assets/images/chargingStatistics/jianBg.png'),
        },
        {
          title: '峰',
          icon: require('@/assets/images/chargingStatistics/fengIcon.png'),
          bg: require('@/assets/images/chargingStatistics/fengBg.png'),
        },
        {
          title: '平',
          icon: require('@/assets/images/chargingStatistics/pingIcon.png'),
          bg: require('@/assets/images/chargingStatistics/pingBg.png'),
        },
        {
          title: '谷',
          icon: require('@/assets/images/chargingStatistics/guIcon.png'),
          bg: require('@/assets/images/chargingStatistics/guBg.png'),
        },
      ],
    };
  },
  methods: {
    // 保留一位小数 String
    toDecimal(val) {
      return val ? val.toFixed(0) : '0';
    },
    handleNavGo() {
      this.$emit('handleNavGo');
    },
  },
};
</script>

<style lang="less" scoped>
.today-stat {
  width: 100%;
  .content {
    box-sizing: border-box;
    width: 100%;
    // height: 280px;
    padding-top: 20px;
    padding-left: 0px;

    .unit-content {
      width: 100%;
      .displayFlex(center);
    }
  }
    .charging-content {
    margin-top: 20px;
    display: flex;
    .sys-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-top: 21px;
        width: 72px;
        height: 26px;
        margin-bottom: 27px;
      }
      .sys-bg {
        width: 110px;
        height: 124px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        display: flex;
        .sys-fgc{
          margin: 0px 0 30px;
        }
        .sys-info {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin-bottom: 5px;
          width: 120px;
        }
        .fgc1 {
          color: #FF7442
        }
        .fgc2 {
          color: #ff5454;
        }
        .fgc3 {
          color: #ffbf39;
        }
        .fgc4 {
          color: #6efbff;
        }
        p {
          font-size: 28px;
          height: 30px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          margin-right: 5px;
          margin-left: 5px;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
